import { NgModule } from '@angular/core';
import { RouterModule } from '@angular/router';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { ClusterLayoutRoutes } from './cluster-layout.routing';
import {MatRadioModule} from '@angular/material/radio';
import {MatIconModule} from '@angular/material/icon';
import {MatListModule} from '@angular/material/list';
import {MatTableModule} from '@angular/material/table';
import {MatExpansionModule} from '@angular/material/expansion';
import {MatBadgeModule} from '@angular/material/badge';
import {MatDatepickerModule} from '@angular/material/datepicker';
// import {GeneralService} from '../../../../services/general.service';
import { NgxChartsModule } from '@swimlane/ngx-charts';
import { SharedModule } from 'app/layouts/shared/shared.module';
import { AddClusterComponent } from 'app/add-cluster/add-cluster.component';
import { MatButtonModule } from '@angular/material/button';
import { MatNativeDateModule, MatRippleModule } from '@angular/material/core';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatSelectModule } from '@angular/material/select';
import { MatTooltipModule } from '@angular/material/tooltip';
import { MatPaginatorModule } from '@angular/material/paginator';
import {MatInputModule} from '@angular/material/input'
import { GoogleChartsModule } from 'angular-google-charts';
import { NgSelectModule } from '@ng-select/ng-select';
import { NgxGaugeModule } from 'ngx-gauge';
import { GeneralService } from 'app/services/general.service';

@NgModule({
  
  imports: [
    CommonModule,
    RouterModule.forChild(ClusterLayoutRoutes),
    FormsModule,
    ReactiveFormsModule,
    MatButtonModule,
    MatRippleModule,
    MatFormFieldModule,
    MatInputModule,
    MatSelectModule,
    MatTooltipModule,
    MatRadioModule,
    MatIconModule,
    MatListModule,
    MatTableModule,
    MatExpansionModule,
    MatPaginatorModule,
    MatBadgeModule,
    NgxChartsModule,
    MatDatepickerModule,
    MatNativeDateModule,
    SharedModule,
     GoogleChartsModule, 
     NgxGaugeModule,
     NgSelectModule
   ],
  declarations: [
    AddClusterComponent
    ],
    providers: [GeneralService]

})

export class ClusterLayoutModule {}
